import {
  IconBanknote,
  IconBlocks,
  IconCalendar,
  IconCertificate,
  IconConnection,
  IconCourt,
  IconDrunkBlocks,
  IconFile,
  IconFloatingQuestion,
  IconGraduationCap,
  IconHandshake,
  IconHistory,
  IconHome,
  IconImage,
  IconImages,
  IconLicense,
  IconNews,
  IconOrganization,
  IconPeople,
  IconQuestion,
  IconSettings,
  IconSportTennis,
  IconStarBadge,
  IconTrophy,
  IconUserIssuedCertificate,
  IconUserIssuedForms,
  IconUserIssuedLicense,
  IconUsers,
  IconUserSettings,
  IconWeb,
  IconWhistle,
} from "@/ui";
import { cn } from "@/utils/cn";

import { NavLinkItemType } from "./NavLink.types";

export type NavLinkIconProps = {
  type: NavLinkItemType;
  className?: string;
  width?: string | number;
  height?: string | number;
};

export const NavLinkIcon = ({ type, className, width, height }: NavLinkIconProps) => {
  const ICONS: { [key in NavLinkItemType]: React.ReactNode } = {
    home: <IconHome className={className} width={width} height={height} />,
    clubs: <IconCourt className={cn("rotate-90", className)} width={width} height={height} />,
    venues: <IconCourt className={cn("rotate-90", className)} width={width} height={height} />,
    tournaments: <IconCalendar className={className} width={width} height={height} />,
    users: <IconUsers className={className} width={width} height={height} />,
    userSettings: <IconUserSettings className={className} width={width} height={height} />,
    licenses: <IconLicense className={className} width={width} height={height} />,
    certificates: <IconCertificate className={className} width={width} height={height} />,
    issuedCertificates: (
      <IconUserIssuedCertificate className={className} width={width} height={height} />
    ),
    applicationForms: <IconFile className={className} width={width} height={height} />,
    issuedApplicationForms: (
      <IconUserIssuedForms className={className} width={width} height={height} />
    ),
    issuedLicenses: <IconUserIssuedLicense className={className} width={width} height={height} />,
    organizations: <IconOrganization className={className} width={width} height={height} />,
    platforms: <IconWeb className={className} width={width} height={height} />,
    sports: <IconSportTennis className={className} width={width} height={height} />,
    disciplines: <IconTrophy className={className} width={width} height={height} />,
    thirdPartyLicenses: <IconCertificate className={className} width={width} height={height} />,
    platformManagers: <IconUsers className={className} width={width} height={height} />,
    platformSettings: <IconSettings className={className} width={width} height={height} />,
    organizationSettings: <IconSettings className={className} width={width} height={height} />,
    news: <IconNews className={className} width={width} height={height} />,
    gallery: <IconImages className={className} width={width} height={height} />,
    documents: <IconLicense className={className} width={width} height={height} />,
    pages: <IconDrunkBlocks className={className} width={width} height={height} />,
    banners: <IconImage className={className} width={width} height={height} />,
    partners: <IconHandshake className={className} width={width} height={height} />,
    transactions: <IconBanknote className={className} width={width} height={height} />,
    stripeConnect: <IconConnection className={className} width={width} height={height} />,
    platformStripeAccounts: <IconConnection className={className} width={width} height={height} />,
    integrations: <IconBlocks className={className} width={width} height={height} />,
    specificVenue: null,
    helpCenter: <IconQuestion className={className} width={width} height={height} />,
    tutorials: <IconGraduationCap className={className} width={width} height={height} />,
    contactSupport: <IconFloatingQuestion className={className} width={width} height={height} />,
    coaches: <IconWhistle className={className} width={width} height={height} />,
    leagues: <IconStarBadge className={className} width={width} height={height} />,
    teams: <IconPeople className={className} width={width} height={height} />,
    managementTeam: <IconUsers className={className} width={width} height={height} />,
    auditLogs: <IconHistory className={className} width={width} height={height} />,
    documentation: <IconBlocks className={className} width={width} height={height} />,
  };

  return ICONS[type];
};
